import HeaderAdminLayout from "./HeaderAdminLayout/HeaderAdminLayout";

const AdminLayout = ({ children }) => {
  return (
    <div className="bg">
      <HeaderAdminLayout />
      <div className="wrapper">{children}</div>
    </div>
  );
};

export default AdminLayout;
